import { createRouter, createWebHistory } from 'vue-router'
import AV from 'leancloud-storage'

// 导入视图组件
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Home from '../views/Home.vue'
import ItemDetail from '../views/ItemDetail.vue'
import StepEdit from '../views/StepEdit.vue'
import Categories from '../views/Categories.vue'
import Settings from '../views/Settings.vue'
import Share from '../views/Share.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/item/:id',
    name: 'ItemDetail',
    component: ItemDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/step/edit/:id',
    name: 'StepEdit',
    component: StepEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/share',
    name: 'Share',
    component: Share,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!AV.User.current()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 